module.exports = __webpack_public_path__ + "img/ideation-09-milestone-modal-bg-01.bbbe219d.jpg";